import  create  from 'zustand';

const useNotificationStore = create((set) => ({
  count:0,
  setCount: (count) => set({ count: count }),
  decrementCount: () => set(state => ({ count: state.count - 1 })),
  resetCount: () => set({ count: 0 }),
}));
export default useNotificationStore;